import { GridWidgetService } from '../grid-widget.services';
import { SystemService } from 'common/services/core-services/system.service';
import { MetaModel } from 'common/models/utility-models/base-model';
import { Injectable } from '@angular/core';
import { AppVersionGridMetaModel } from 'common/models/page-models/App Version Model/app-version-grid-meta.model';
import { AppVersionModel } from 'common/models/page-models/App Version Model/app-version-form-model';
import { AppVersionListingModel } from 'common/models/page-models/App Version Model/app-version-grid.model';
import { AppVersionGridDataService } from 'common/services/data-services/admin/app-version/app-version-grid-data.service';



 
@Injectable({
    providedIn: 'root'
})
export class AppVersionGridWidgetService extends GridWidgetService<AppVersionModel, AppVersionListingModel> {
    constructor(protected override ds: AppVersionGridDataService, protected ss: SystemService) {
        super(ds);
    }
 
    getMetaModel(): MetaModel {
        const meta = new AppVersionGridMetaModel().getMetaModel();
        return meta;
    }
    Save(body, url) {
        this.ds.postLoginData(body, url).then((response) => {
          
          if (response.status === 'Success') {
            this.ss.showSuccess(response.msg);
          }
    
        });
      }
}